module.exports = __webpack_public_path__ + "img/thank_2021_tip2_mall.c908a9a9.png";